var map = {
	"./Pictos Weevapp.svg": 47396,
	"./Pictos Weevapp_Accès PMR.svg": 80008,
	"./Pictos Weevapp_Autoroute.svg": 58084,
	"./Pictos Weevapp_Aéroport.svg": 55663,
	"./Pictos Weevapp_Cabaret.svg": 81622,
	"./Pictos Weevapp_Capacité max assis-06.svg": 71815,
	"./Pictos Weevapp_Capacité max assis-15.svg": 25590,
	"./Pictos Weevapp_Capacité max debout.svg": 11331,
	"./Pictos Weevapp_Cocktail.svg": 64810,
	"./Pictos Weevapp_Conférence.svg": 62752,
	"./Pictos Weevapp_Couchage max.svg": 26617,
	"./Pictos Weevapp_Dance.svg": 53803,
	"./Pictos Weevapp_En U.svg": 56224,
	"./Pictos Weevapp_Gala.svg": 6349,
	"./Pictos Weevapp_Hôtel.svg": 96970,
	"./Pictos Weevapp_Lumière du jour.svg": 33288,
	"./Pictos Weevapp_Métro.svg": 80719,
	"./Pictos Weevapp_Nb de chambres.svg": 33738,
	"./Pictos Weevapp_Nb de single.svg": 89051,
	"./Pictos Weevapp_Nb de twin.svg": 78910,
	"./Pictos Weevapp_Nombre de salles.svg": 4362,
	"./Pictos Weevapp_Rang d'école.svg": 89103,
	"./Pictos Weevapp_Réunion.svg": 24876,
	"./Pictos Weevapp_Surface max .svg": 32525,
	"./Pictos Weevapp_Train.svg": 39120,
	"./Pictos Weevapp_Tram.svg": 50934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;